export enum ClientProjectEnvironmentEnum  {
    Dev= "Dev",
    QA = "QA",
    ClientDev = "Client DEV",
    Beta = "BETA",
    Demo = "DEMO",
    ProdStaging = "PROD Staging",
    Prod = "PROD"
}
